module.exports = __webpack_public_path__ + "media/site/images/products/ekanban-screen@2x-c6256d967551e361d92d494b00ba224c.png";